module.exports = __webpack_public_path__ + "img/LanEn_icon.48afc3a3.png";